export default "__VITE_ASSET__CQAW0XpJ__"